import SectionServiceContent from "./section-service-content-3"

export default function SectionServiceDetail() {
    return (
        <>
            <div className="service-full-info">
                <div className="services-etc m-b30">
                    
                    <SectionServiceContent />

                </div>
            </div>
        </>
    )
}